export const tableFiltersValuesConstants = {
  EDIT_FILTER_VALUE: 'EDIT_FILTER_VALUE'
};
